import React from 'react';

const IconArrowRightWhite = props => (
  <svg width={15} height={25} viewBox="0 0 15 25" {...props}>
    <path
      d="M10.949 13.206L.708 2.376A1.184 1.184 0 0 1 .718.737a1.088 1.088 0 0 1 1.572.01l11.904 12.589L2.29 24.124a1.092 1.092 0 0 1-1.572-.11 1.188 1.188 0 0 1 .115-1.64l10.115-9.168z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);

export default IconArrowRightWhite;
